/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import showformmodel from "../showformmodel/showformmodel.vue";
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import VisitActivityModal from "../VisitActivityOrder/VisitActivityOrder.vue"

export default {
  name: "VisitActivityTree",

  components: { showformmodel, manageVisitModal, VisitActivityModal },
  props: {
    version: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      token: store.getters.getIdToken,
      head: {},
      studyId: "",
      loading: false,
      currentArmCode: null,
      isEditing: false,
      armList: [],
      visitList: {},
      activityList: {},
      formList: {},


      openArms: [],
      openVisits: [],
      openActivities: [],
      showVisitPopup: [],
      showVisitEditModal: false,
      visitId: null,


      setshowActivityFormModal: false,
      formActivityId: "",
      showSiteModal: false,
      SelectedVisitId: null,
      showActivityModal: false,
      selectedVersion: "",

    };
  },

  async mounted() {
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    };
    window.addEventListener("studyIdChanged", async () => {

      this.studyId = store.getters.getStudyIs;
      this.armList = [];
      this.visitList = {};
      this.activityList = {};
      this.formList = {};
      this.openArms = [];
      this.openVisits = [];
      this.openActivities = [];
      await this.getStudyArms();

    });

    this.studyId = store.getters.getStudyIs;
    this.selectedVersion = this.version || "";

    await this.getStudyArms();
  },

  methods: {
    async getStudyArms() {
      try {
        const res = await axios.get(
          `${this.baseapi}/fhir-service/arm/getarmsbystudyid?study_id=${this.studyId}`,
          this.head
        );

        this.armList = Array.isArray(res.data) ? res.data : [];
        this.visitList = {};

        this.armList.forEach(a => {
          this.visitList[a.ArmCode] = [];
        });

      } catch (err) {
        console.error("Error fetching arms", err);
      }
    },

    async toggleArm(armCode) {
      if (!this.openArms.includes(armCode)) {
        this.openArms.push(armCode);
      } else {
        this.openArms = this.openArms.filter(a => a !== armCode);
        return;
      }

      try {
        const res = await axios.get(
          `${this.baseapi}/management/visit/listvisit?StudyId=${this.studyId}&ArmCode=${armCode}`,
          this.head
        );

        this.visitList[armCode] = res.data.results || [];

        this.visitList[armCode].forEach(v => {
          this.activityList[v.visitId] = [];
        });

      } catch (err) {
        console.error("Error loading visits", err);
      }
    },

    async toggleVisit(armCode, visitId) {
      if (!this.openVisits.includes(visitId)) {
        this.openVisits.push(visitId);
      } else {
        this.openVisits = this.openVisits.filter(v => v !== visitId);
        return;
      }

      try {
        const res = await axios.get(
          `${this.baseapi}/management/visit/listvisitactivity?visitId=${visitId}`,
          this.head
        );

        this.activityList[visitId] = res.data.entities || [];

        this.activityList[visitId].forEach(a => {
          this.formList[a.activityId] = [];
        });

      } catch (err) {
        console.error("Error loading activities", err);
      }
    },

    async toggleActivity(activityId) {
      if (!this.openActivities.includes(activityId)) {
        this.openActivities.push(activityId);
      } else {
        this.openActivities = this.openActivities.filter(a => a !== activityId);
        return;
      }

      try {
        const res = await axios.get(
          `${this.baseapi}/management/study/getsoa?Id=${activityId}`,
          this.head
        );

        this.formList[activityId] = res.data.eCRF || [];

      } catch (err) {
        console.error("Error loading forms", err);
      }
    },
    viewForms(tempId) {
      console.log('viewForms called', tempId)
      this.formActivityId = tempId;
      this.setshowActivityFormModal = true;
    },
    closeformActivityModal() {
      this.setshowActivityFormModal = false;
    },
    editVisit(visitId, armCode) {
      this.closePopover(`visit-popup-${visitId}`);
      this.showSiteModal = true;
      this.visitId = visitId;
      this.currentArmCode = armCode;
    },
    // editVisit(visitId) {
    //     this.closePopover(`visit-popup-${visitId}`);
    //         this.showSiteModal = true;
    //         this.visitId = visitId;
    //         this.currentArmCode = armCode;
    //     },
    async deleteVisit(visitId) {
      this.closePopover(`visit-popup-${visitId}`);
      if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
        try {
          await axios.delete(
            `${this.baseapi}/management/visit/delete?id=${visitId}`,
            this.head
          );

          alert(this.$t("navigations.visit deleted successfully"));

          Object.keys(this.visitList).forEach(armCode => {
            this.visitList[armCode] = this.visitList[armCode].filter(v => v.visitId !== visitId);
          });

        } catch (err) {
          alert(this.$t("navigations.failed due to internal error"));
          console.error(err);
        }
      }
    },
    openVisitActivityModal(visitId) {
      this.closeAllPopovers();
      this.visitId = visitId;
      this.showActivityModal = true;
      this.$emit("openActivityAssignModal", visitId);
    },
    async closeModal() {
      this.showSiteModal = false;
      await this.toggleArm(this.currentArmCode);
    },
    closePopover(popoverId) {
      const popover = document.getElementById(popoverId);
      if (popover && typeof popover.hidePopover === 'function') {
        popover.hidePopover();
      }
    },

    closeAllPopovers() {

      this.armList.forEach(arm => {
        this.closePopover(`arm-popup-${arm.ArmCode}`);
      });

      Object.keys(this.visitList).forEach(armCode => {
        this.visitList[armCode].forEach(visit => {
          this.closePopover(`visit-popup-${visit.visitId}`);
        });
      });
    },
    handleCreateVisit(armCode) {
      const popup = document.getElementById(`arm-popup-${armCode}`);
      popup?.hidePopover?.();
      console.log("Creating visit for arm:", armCode);
      this.visitId = 0;
      this.currentArmCode = armCode;
      this.selectedArm = armCode;
      this.isEditing = false;
      this.showSiteModal = true;
    },
    closeActivitModal() {
      this.showActivityModal = false;
      this.toggleArm(this.currentArmCode);

    },
    refreshVisitList() {
      this.toggleArm(this.currentArmCode);
    },



  }
};
